/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { getUserByToken, login } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    // .email("Format incorrect de l'adresse e-mail")
    .min(3, 'Minimum 3 caractères')
    .max(50, 'Maximum 50 caractères')
    .required("L'adresse e-mail est requise"),
  password: Yup.string()
    .min(3, 'Minimum 3 caractères')
    .max(50, 'Maximum 50 caractères')
    .required('Le mot de passe est requis'),
})

const initialValues = {
  username: 'admin',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const { data: auth } = await login(values.username, values.password)

        saveAuth({ token: auth.result.token })
        const { data: user } = await getUserByToken(auth.result.token)
        setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('Les détails de connexion sont incorrects.')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form className='form w-100' onSubmit={formik.handleSubmit} noValidate id='login_signin_form'>
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1
          style={{
            color: '#F07C07',
          }}
          className='text-primary-active fw-bolder mb-3'
        >
          Connectez-vous pour continuer à
        </h1>
        <img src={toAbsoluteUrl('/media/misc/logo_blue_login.png')} alt='' />
        {/* <div className='text-gray-500 fw-semibold fs-6'>A vos société</div> */}
      </div>
      {/* begin::Heading */}

      {/* begin::Separator */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>SaleSphere</span>
      </div> */}
      {/* end::Separator */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div></div>
        // <div className='mb-10 bg-light-info p-8 rounded'>
        //   {/* <div className='text-info'>
        //     Use account <strong>admin</strong> and password <strong>admin</strong> to continue.
        //   </div> */}
        // </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        {/* <label className='form-label fs-6 text-gray-500'>Nom</label> */}
        <input
          placeholder='Nom'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-bottom-border bg-transparent',
            { 'is-invalid': formik.touched.username && formik.errors.username },
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        {/* <label className='form-label text-gray-500 fs-6 mb-0'>Mot de passe</label> */}
        <input
          placeholder='Mot de passe'
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-bottom-border',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        {/* begin::Link */}
        {/* <Link to='/auth/forgot-password' className='text-gray-500 disabled'>
          Oubliez votre mot de passe ?
        </Link> */}
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-flex justify-content-center mb-10'>
        <button
          type='submit'
          id='sign_in_submit'
          className='btn btn-customized w-75 '
          disabled={formik.isSubmitting || !formik.isValid}
          style={{ borderRadius: "15px" }}
        >
          {!loading && <span className='indicator-label fw-bold'>Se connecter</span>}
          {loading && (
            <span className='indicator-progress fw-light' style={{ display: 'block' }}>
              Veuillez patienter...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Pas encore membre ?{' '}
        <Link to='/auth/registration' className='link-primary'>
          S'inscrire
        </Link>
      </div> */}
    </form>
  )
}
